import { ArrowUp } from "lucide-react";
import { NAV_LINKS, PRODUCTS } from "../data/site";

export const Footer = ({ lenis }) => {
    const go = (e, href) => {
        e.preventDefault();
        if (lenis) lenis.scrollTo(href, { offset: -64, duration: 1.4 });
        else document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
    };

    return (
        <footer data-testid="site-footer" className="border-t border-line bg-ink">
            <div className="mx-auto max-w-screen-2xl px-6 pb-10 pt-16 md:px-12 md:pt-24">
                <p className="text-outline font-display text-[11vw] uppercase leading-none tracking-tight md:text-[7.5vw]">
                    SVS Balaji
                </p>
                <div className="mt-14 grid gap-10 border-t border-line pt-10 md:grid-cols-4">
                    <div>
                        <img
                            src="/logo.png"
                            alt="SVS Balaji Industries logo"
                            className="mb-4 h-14 w-14 rounded-full"
                        />
                        <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-ember">
                            SVS Balaji Industries
                        </p>
                        <p className="mt-3 max-w-xs text-sm leading-relaxed text-zinc-500">
                            Automotive forgings, castings and precision machining. Forged
                            in India, trusted worldwide.
                        </p>
                    </div>
                    <div>
                        <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500">
                            Site
                        </p>
                        <ul className="mt-3 space-y-2">
                            {NAV_LINKS.map((l) => (
                                <li key={l.href}>
                                    <a
                                        href={l.href}
                                        data-testid={`footer-link-${l.label.toLowerCase()}`}
                                        onClick={(e) => go(e, l.href)}
                                        className="text-sm text-zinc-400 transition-colors hover:text-ember"
                                    >
                                        {l.label}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div>
                        <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500">
                            Products
                        </p>
                        <ul className="mt-3 space-y-2">
                            {PRODUCTS.slice(0, 5).map((p) => (
                                <li key={p.name} className="text-sm text-zinc-400">
                                    {p.name}
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="flex flex-col justify-between gap-8">
                        <div>
                            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500">
                                Domain
                            </p>
                            <p className="mt-3 text-sm text-zinc-400">
                                svsbalajiindustries.com
                            </p>
                        </div>
                        <a
                            href="#home"
                            data-testid="back-to-top-btn"
                            onClick={(e) => go(e, "#home")}
                            className="flex w-fit items-center gap-2 border border-line px-5 py-3 font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-400 transition-colors hover:border-ember hover:text-ember"
                        >
                            Back to top <ArrowUp size={14} />
                        </a>
                    </div>
                </div>
                <div className="mt-12 flex flex-wrap items-center justify-between gap-4 border-t border-line pt-6">
                    <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-600">
                        © 2026 SVS Balaji Industries. All rights reserved.
                    </p>
                    <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-600">
                        GST 33BZEPS6629D1ZB · ISO 9001:2015 · IATF 16949:2016
                    </p>
                </div>
            </div>
        </footer>
    );
};
